export default {
    internal_server_error: 'មាន បញ្ហា  សូម ព្យាយាម ម្ដងទៀត នៅ ពេលក្រោយ។',
    require_username: 'សូមបញ្ចូលឈ្មោះអ្នកប្រើ',
    require_password: 'សូមបញ្ចូលពាក្យសម្ងាត់',
    wrong_username_password: 'ឈ្មោះអ្នកប្រើ ឬពាក្យសម្ងាត់ខុស!',
    fail_to_load_clients: 'បរាជ័យក្នុងការផ្ទុកអតិថិជន!',
    fail_to_load_invoices: 'បរាជ័យក្នុងការផ្ទុកវិក្ក័យប័ត្រ!',
    fail_to_load_client_domains: 'បរាជ័យក្នុងការផ្ទុកដែនរបស់អតិថិជន',
    fail_to_load_client: 'បរាជ័យក្នុងការផ្ទុកព័ត៌មានអតិថិជន',
    fail_to_load_setting: 'បរាជ័យក្នុងការផ្ទុកអត្រាកំរៃជើងសារ',
    fail_to_save_setting: 'បរាជ័យក្នុងការរក្សាទុកអត្រាកំរៃជើងសារ',
    save_setting_success: 'រក្សាទុកអត្រាកំរៃជើងសារជោគជ័យ',
    save_invoice_success: 'រក្សាទុកវិក្ក័យប័ត្រជោគជ័យ',
    fail_to_save_invoice: 'បរាជ័យក្នុងការរក្សាទុកវិក្ក័យប័ត្រ',
    require_commission: 'សូមបញ្ចូលកម្រៃជើងសារ',
    integer: 'សូមបញ្ចូលចំនួនគត់',
    rage_0_100: 'ត្រូវតែធំជាង 0 និងតិចជាង ១០០០',
    require_status: 'សូមជ្រើសរើសស្ថានភាព',
    require_current_password: 'សូមបញ្ចូលពាក្យសម្ងាត់ចាស់',
    require_new_password: 'សូមបញ្ចូលពាក្យសម្ងាត់ថ្មី។',
    require_confirm_password: 'សូមបញ្ជាក់ពាក្យសម្ងាត់',
    confirm_password_not_match:
        'បញ្ជាក់ពាក្យសម្ងាត់មិនត្រូវនឹងពាក្យសម្ងាត់ថ្មីទេ។',
    password_rage_length:
        'ប្រវែងពាក្យសម្ងាត់ត្រូវតែមានចាប់ពី {min} ដល់ {max} តួអក្សរ',
    password_white_space: 'ពាក្យសម្ងាត់មិនរួមបញ្ចូលដកឃ្លាទេ',
    save_password_success: 'ធ្វើអាប់ដេតសម្ងាត់ជោគជ័យ',
    wrong_password: 'លេខសម្ងាត់ ខុស',
    invalid_password:
        'ពាក្យសម្ងាត់ត្រូវតែមានយ៉ាងហោចណាស់អក្សរធំមួយ អក្សរតូចមួយ លេខមួយ',
    date_from_to: 'កាលបរិច្ឆេទចាប់ផ្តើមត្រូវតែតិចជាងកាលបរិច្ឆេទបញ្ចប់',
    amount_from_to: 'ចំនួនទឹកប្រាក់ចាប់ផ្តើមត្រូវតែតិចជាងចំនួនបញ្ចប់',
    earned_from_to:
        'ការចាប់ផ្តើមរកកំរ៉ៃបានត្រូវតែតិចជាងការបញ្ចប់ដែលទទួលបានកំរ៉ៃ',
    discount_from_to:
        'ការបញ្ចុះតម្លៃចាប់ផ្តើមត្រូវតែស្មើគ្នា ឬតិចជាងការបញ្ចុះតម្លៃចុងក្រោយ',
    require_date_from: 'ការបរិច្ឆេទចាប់ផ្តើមគឺតម្រូវអោយមាន',
    require_date_to: 'ការបរិច្ឆេទបញ្ចប់គឺតម្រូវអោយមាន',
    update_status_success: 'អាប់ដេតស្ថានភាពជោគជ័យ',
    required_mail_box: 'ប្រអប់សំបុត្រគឺតម្រូវអោយមាន',
    max_mail_box: 'ប្រអប់សំបុត្រវែងពេក',
    invalid_mail_box: 'ប្រអប់សំបុត្រមិនត្រឹមត្រូវ',
    required_forward_to: 'បញ្ជូនបន្តទៅគឺតម្រូវអោយមាន',
    email_forward_to: 'បញ្ជូនបន្តទៅត្រូវតែជាអ៊ីមែល',
    max_forward_to: 'បញ្ជូនបន្តទៅវែងពេក',
    invalid_host_name: 'ប្រភព URL មិនត្រឹមត្រូវ',
    required_host_name: ' ប្រភព URL គឺតម្រូវអោយមាន',
    max_host_name: 'ប្រភព URL វែងពេក',
    invalid_domain: 'ដែន មិន ត្រឹមត្រូវ។',
    invalid_connect_domain:
        "សូមបញ្ចូលដែនដែលមានសុពលភាព។ ដែនមិនអាចចាប់ផ្តើមដោយ 'www.'",
    required_address: 'URL គោលដៅគឺតម្រូវអោយមាន',
    max_address: 'URL គោលដៅវែងពេក',
    invalid_address:
        'URL មិនត្រឹមត្រូវ។ ប្រើពិធីការត្រឹមត្រូវ។ ឧទាហរណ៍៖ <b>https://example.com</b> ឬ <b>http://example.com</b>',
    power_action_error:
        'បរាជ័យក្នុង {value} ។ សូម ព្យាយាម ម្តង ទៀត នៅ ពេល ក្រោយ',
    power_state_error: 'បរាជ័យក្នុងការទទួលស្ថានភាពថាមពលរបស់ម៉ាស៊ីនមេ',
    power_restart_success: 'ចាប់ផ្តើមម៉ាស៊ីនមេឡើងវិញដោយជោគជ័យ',
    country_not_available:
        'ប្រទេសនេះត្រឹមត្រូវនឹង <b>{tld}</b> ទេ។ សូមជ្រើសរើសប្រទេសផ្សេង',
    required_first_name: 'សូមបញ្ចូលឈ្មោះ',
    required_last_name: 'សូមបញ្ចូលនាមត្រកូល',
    required_address_profile: 'សូមបញ្ចូលអាស័យដ្ឋាន',
    required_postal_code: 'សូមបញ្ចូលលេខកូដប្រៃសណីយ៍',
    required_country: 'សូមជ្រើសរើសប្រទេស',
    required_city: 'សូមបញ្ចុលទីក្រុង',
    required_state_province: 'សូមបញ្ចូលរដ្ឋ/ខេត្ត',
    required_phone: 'សូមបញ្ចូលលេខទូរស័ព្ទ',
    required_email: 'សូមបញ្ចូលអាស័យដ្ឋានអ៊ីមែល',
    invalid_email: 'អ៊ីមែល មិន ត្រឹមត្រូវ។',
    invalid_postal_code: 'លេខកូដប្រៃសណីយ៍ខុសសទម្រង់នឹងប្រទេសដែលបានជ្រើសរើស',
    failed_to_load_wallet_history: 'បានបរាជ័យក្នុងការផ្ទុកប្រវត្តិកាបូប។',
    bank_name_required: 'ឈ្មោះធនាគារតម្រូវអោយមាន',
    bank_name_max: 'ឈ្មោះធនាគារមិនត្រូវបានអនុញ្ញាតឱ្យធំជាង ២៥៥ តួអក្សរទេ។',
    account_number_required: 'លេខគណនីតម្រូវអោយមាន',
    account_number_max: 'លេខគណនីមិនអនុញ្ញាតឱ្យធំជាង ៣៤ តួអក្សរទេ។',
    account_name_required: 'ឈ្មោះគណនីត្រូវតម្រូវអោយមាន',
    account_name_max: 'ឈ្មោះគណនីមិនអនុញ្ញាតឱ្យធំជាង ២៥៥ តួអក្សរទេ។',
    amount_required: 'ចំនួនទឹកប្រាក់តម្រូវអោយមាន',
    amount_min: 'ចំនួនទឹកប្រាក់អប្បបរមាគឺ ១០ ដុល្លារ',
    amount_less_than: 'ចំនួនទឹកប្រាក់ត្រូវតែតិចជាង {max}',
    amount_withdraw_greater_than_balance:
        'សមតុល្យមិនគ្រប់គ្រាន់សម្រាប់ការដកប្រាក់ទេ។',
    update_successful: 'អាប់ដេតបានជោគជ័យ',
    fail_to_load_data: 'បរាជ័យក្នុងការផ្ទុកទិន្នន័យ',
    invalid_file: 'ទម្រង់ឯកសារមិនត្រឹមត្រូវ។',
    max_file_size: 'ទំហំឯកសារអតិបរមាគឺ {size}',
    invalid_brand_name: 'ឈ្មោះម៉ាកមិនត្រឹមត្រូវ',
    required_brand_name: 'ឈ្មោះម៉ាកតម្រូវអោយមាន',
    file_required: 'ការ ផ្ទុក ឯកសារ តម្រូវអោយមាន',
    required_category: 'ប្រភេទតម្រូវអោយមាន',
    required_content: 'ខ្លឹមសារត្រូវតម្រូវអោយមាន',
    max_content:
        'ចំនួនអតិបរមានៃសារ SMS គឺ {value} ។ សូមធ្វើអាប់ដេតខ្លឹមសាររបស់អ្នក។',
    required_subject: 'ប្រធានបទតម្រូវអោយមាន',
    required_sender: 'តម្រូវ ការរបស់ ឈ្មោះ យីហោ',
    max_subject: 'ប្រធានបទវែងពេក',
    max_category: 'ប្រភេទវែងពេក',
    required_group_name: 'ឈ្មោះក្រុមត្រូវតែមាន',
    required_full_name: 'ឈ្មោះពេញត្រូវតែមាន',
    required_phone_number: 'ទូរស័ព្ទត្រូវតែមាន',
    max_full_name: 'ឈ្មោះពេញត្រូវតែតិចជាង {max}',
    required_date_of_birth: 'ថ្ងៃកំណើតត្រូវមាន',
    invalid_date: 'កាលបរិច្ឆេទ មិន ត្រឹមត្រូវ។',
    invalid_phone: 'លេខទូរស័ព្ទមិនត្រឹមត្រូវ',
    send_sms_success: 'ផ្ញើសារ SMS ជោគជ័យ',
    content_must_has_character: 'ខ្លឹមសារត្រូវតែមានយ៉ាងហោចណាស់ 1 តួអក្សរ',
    required_date: 'កាលបរិច្ឆេទត្រូវតែមាន',
    duplicate_phone: 'លេខទូរស័ព្ទមានរួចហើយ',
    required_future_date: 'សូមបញ្ចូលពេលវេលានាខាងមុខ',
    before_leave_confirm_mgs:
        'ទិន្នន័យរបស់អ្នកនឹងត្រូវបាត់បង់! តើអ្នកប្រាកដថាចង់ចាកចេញទេ?',
    are_you_sure: 'តើ​អ្នក​ប្រាកដ​ឬ​អត់?',
    delete_record_confirm_message: 'អ្នកប្រាកដថាចង់លុបកំណត់ត្រាមែនទេ?',
    delete_record: 'លុបចោលកំណត់ត្រា?',
    please_enter_value: 'សូមបញ្ចូលតម្លៃ',
    successful: 'ជោគជ័យ',
    please_add_mx_record: 'សូមបន្ថែម MX Record',
    invalid_nameserver: 'ឈ្មោះម៉ាស៊ីនមេមិនត្រឹមត្រូវទេ',
    email_wrong_format: 'អាសយដ្ឋានអ៊ីមែលមានទម្រង់ខុស',
    required_description: 'ការពិពណ៌នាត្រូវបានទាមទារ',
    phone_wrong_format: 'ទូរស័ព្ទមានទម្រង់ខុស',
    required_domain: 'សូមបញ្ចូល domain',
    update_main_domain_success: 'Domainរបស់អ្នកត្រូវបានធ្វើកា updated',
    copied_to_clipboard: 'បានចម្លងទៅក្ដារតម្បៀតខ្ទាស់',
    email_verified: 'អាសយដ្ឋានអ៊ីមែលរបស់អ្នកត្រូវបានផ្ទៀងផ្ទាត់',
    send_otp_success: 'លេខកូដ OTP ត្រូវបានផ្ញើ',
    turn_on_auto_renewal_title: 'បើកការបន្តដោយស្វ័យប្រវត្តិ',
    turn_off_auto_renewal_title: 'បិទការបន្តដោយស្វ័យប្រវត្តិ',
    turn_on_auto_renewal_content: `អ្នករៀបនឹងបើកការបន្តដោយស្វ័យប្រវត្តិសម្រាប់សេវាកម្មរបស់អ្នក។`,
    turn_off_auto_renewal_content: `អ្នករៀបនឹងបិទការបន្តដោយស្វ័យប្រវត្តិសម្រាប់សេវាកម្មរបស់អ្នក។`,
    required_server_name: 'សូមបញ្ចូលឈ្មោះម៉ាស៊ីនមេ',
    max_server_name: 'ឈ្មោះម៉ាស៊ីនមេត្រូវតែខ្លីជាងឬស្មើនឹង៤០ តួអក្សរ',
    update_server_name_success: 'ធ្វើបច្ចុប្បន្នភាព Server name ជោគជ័យ',
    company_name_max_length:
        'ឈ្មោះក្រុមហ៊ុនមិនត្រូវបានអនុញ្ញាតឱ្យធំជាង {max} តួអក្សរទេ។',
    company_address_max_length:
        'អាសយដ្ឋានក្រុមហ៊ុនមិនត្រូវបានអនុញ្ញាតឱ្យធំជាង {max} តួអក្សរទេ។',
    vat_tin_max_length: 'VAT TIN មិនត្រូវបានអនុញ្ញាតឱ្យធំជាង {max} តួអក្សរទេ។',
    company_phone_max_length:
        'ទូរសព្ទរបស់ក្រុមហ៊ុនមិនត្រូវបានអនុញ្ញាតឱ្យធំជាង {max} តួអក្សរទេ។',
    representative_max_length:
        'ឈ្មោះតំណាងមិនត្រូវបានអនុញ្ញាតឱ្យធំជាង {max} តួអក្សរទេ។',
    disable_pop_up_blocker:
        'សូមបិទកម្មវិធីទប់ស្កាត់ការលេចឡើងរបស់អ្នក ហើយព្យាយាមម្តងទៀត',
    card_saved_success: 'កាតនេះត្រូវបានរក្សាទុកដោយជោគជ័យ',
    card_added_success: 'កាតថ្មីរបស់អ្នកត្រូវបានបញ្ចូលរួចរាល់',
    payment_method_saved_success:
        'វិធីបង់ប្រាក់ត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ',
    payment_deleted_card_success: 'កាតនេះត្រូវបានលុបដោយជោគជ័យ',
    payment_user_info_missing:
        'បានបាត់ព័ត៌មានផ្ទាល់ខ្លួនមួយចំនួន។ សូមបញ្ចូលព័ត៌មានរបស់អ្នកមុនពេលបញ្ចូលកាត។',
    invalid_name: 'ឈ្មោះ មិន ត្រឹមត្រូវ។ វាមិនត្រូវមានលេខ ឬតួអក្សរពិសេសទេ។',
    invalid_billing_address:
        'អាសយដ្ឋានមិនត្រឹមត្រូវ។ វាមិនត្រូវមានតួអក្សរពិសេសដូចជា៖ | \\ {} [] <>',
    invalid_city:
        'ទីក្រុងមិនត្រឹមត្រូវ។  វាមិនត្រូវមានតួអក្សរពិសេសដូចជា៖ | \\ {} [] <>',
    invalid_state_province:
        'ខេត្តមិនត្រឹមត្រូវ។  វាមិនត្រូវមានតួអក្សរពិសេសដូចជា៖ | \\ {} [] <>',
    cancel_sms_transaction_success: 'ប្រតិបត្តិការនេះត្រូវបានលុបចោលដោយជោគជ័យ',
    authentication_code_required: 'សូមបញ្ចូលលេខកូដផ្ទៀងផ្ទាត់',
    min_authentication_code: 'លេខកូដផ្ទៀងផ្ទាត់ត្រូវតែមានយ៉ាងហោចណាស់ {min} លេខ',
    max_authentication_code:
        'លេខកូដផ្ទៀងផ្ទាត់ត្រូវតែខ្លីជាង ឬស្មើនឹងលេខ {max}',
    two_fa_enabled: 'ការផ្ទៀងផ្ទាត់ពីរកត្តាត្រូវបានបើក',
    two_fa_disabled: 'ការផ្ទៀងផ្ទាត់កត្តាពីរត្រូវបានបិទ',
    invalid_2fa_code: 'លេខកូដផ្ទៀងផ្ទាត់មិនត្រឹមត្រូវ',
    required_website_name: 'សូមបញ្ចូលឈ្មោះគេហទំព័រ',
    max_website_name: 'ឈ្មោះគេហទំព័រត្រូវតែខ្លីជាង ឬស្មើនឹង {max} តួអក្សរ',
    website_name_saved_success: 'ឈ្មោះគេហទំព័រត្រូវបានរក្សាទុកដោយជោគជ័យ',
    delete_backup_confirm:
        'តើអ្នកប្រាកដថាចង់លុបការបម្រុងទុកដែលមានឈ្មោះឯកសារគឺ {fileName}?',
    delete_backup_success: 'ការបម្រុងទុកនេះត្រូវបានលុបដោយជោគជ័យ',
    upgrade_wp_plugin_confirm:
        'តើអ្នកប្រាកដថាចង់ដំឡើងកម្មវិធីជំនួយ {pluginName} មែនទេ?',
    activate_plugin_success:
        'កម្មវិធីជំនួយ {pluginName} ត្រូវបានបើកដំណើរការដោយជោគជ័យ',
    deactivate_plugin_success:
        'កម្មវិធីជំនួយ {pluginName} ត្រូវបានបិទដំណើរការដោយជោគជ័យ',
    delete_wp_plugin_confirm:
        'តើអ្នកប្រាកដថាចង់លុបកម្មវិធីជំនួយ {pluginName} ទេ?',
    delete_wp_plugin_success: '{pluginName} កម្មវិធីជំនួយត្រូវបានលុបដោយជោគជ័យ',
    upgrade_wp_plugin_success: 'Plugin {pluginName} បានតម្លើងដោយជោគជ័យ',
    generate_ftp_account_success: 'គណនី FTP ត្រូវបានបង្កើតដោយជោគជ័យ',
    revoke_ftp_account_success: 'គណនី FTP ត្រូវបានដកហូតដោយជោគជ័យ',
    generate_db_account_success: 'គណនីមូលដ្ឋានទិន្នន័យត្រូវបានបង្កើតដោយជោគជ័យ',
    revoke_db_account_success: 'គណនីមូលដ្ឋានទិន្នន័យត្រូវបានដកហូតដោយជោគជ័យ',
    upgrade_wp_confirm: 'តើ​អ្នក​ប្រាកដ​ជា​ចង់​ upgrade WordPress មែនទេ?',
    upgrade_theme_success: 'រចនាបថ {themeName} ត្រូវបានដំឡើងកំណែដោយជោគជ័យ',
    regenerate_ftp_db_url_success:
        'FTP និង phpMyAdmin URL ត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ',
    delete_theme_success: 'រចនាបថ {themeName} ត្រូវបានលុបដោយជោគជ័យ',
    activate_theme_success: 'រចនាបថ {themeName} ត្រូវបានដំណើរការដោយជោគជ័យ',
    waiting_for_processing: 'កំពុងរង់ចាំដំណើរការ',
    wait_download_done:
        'បច្ចុប្បន្នអ្នកកំពុងដំណើរការបន្ត។ សូមរង់ចាំការបញ្ចប់មុននឹងបន្ត។',
    max_backup_note:
        'កត់ត្រាការបម្រុងទុក  ដាច់ខាតត្រូវតែខ្លី  ឬ ស្មេី {max} តួអក្សរ',
    csr_required: 'CSR ត្រូវបានទាមទារ',
    csr_invalid: 'CSR មិនត្រឹមត្រូវទេ។',
    domain_invalid: 'ដែនមិនត្រឹមត្រូវ',
    required_company_name: 'ឈ្មោះក្រុមហ៊ុនត្រូវបានទាមទារ',
    email_has_been_resent: 'អ៊ីមែលបញ្ជាក់សុពលភាពត្រូវបានផ្ញើឡើងវិញ',
    duplicated_domain: 'អ្នក បាន បញ្ចូល ដែន នេះ រួច ហើយ',
    max_company_business_name:
        'ឈ្មោះអាជីវកម្មរបស់ក្រុមហ៊ុន មិនអនុញ្ញាតឱ្យធំជាង {max} តួអក្សរទេ។',
    max_company_registration_number:
        'លេខចុះឈ្មោះ មិនអនុញ្ញាតឱ្យធំជាង {max} តួអក្សរទេ។',
    max_state_province: 'រដ្ឋ មិនអនុញ្ញាតឱ្យធំជាង {max} តួអក្សរទេ។',
    max_city: 'ទីក្រុង មិនអនុញ្ញាតឱ្យធំជាង {max} តួអក្សរទេ។ ',
    max_postal_code: 'ប្រៃសណីយ៌ មិន​អនុញ្ញាត​ឱ្យ​ធំ​ជាង {max} តួអក្សរ',
    max_legal_address: 'អាសយដ្ឋាន មិន​​អនុញ្ញាត​ឱ្យ​ធំ​ជាង {max} តួអក្សរ',
    max_country: 'ប្រទេស មិន​អនុញ្ញាត​ឱ្យ​ធំ​ជាង {max} តួអក្សរ',
    organization_first_name: 'ឈ្មោះដំបូង មិនអនុញ្ញាតឱ្យធំជាង {max} តួអក្សរ',
    organization_last_name: 'នាមត្រកូល មិនអនុញ្ញាតឱ្យធំជាង {max} តួអក្សរ',
    job_title: 'ចំណងជើងការងារ មិនអនុញ្ញាតឱ្យធំជាង {max} តួអក្សរ',
    organization_email: 'អ៊ីមែលរបស់ស្ថាប័ន មិនអនុញ្ញាតឱ្យធំជាង {max} តួអក្សរ',
    invalid_registration_number: 'លេខចុះឈ្មោះមិនត្រឹមត្រូវ',
    edit_dcv_method_success:
        'ផ្លាស់ប្តូរវិធីសាស្ត្រ DCV សម្រាប់ {domains} ដោយជោគជ័យ!',
    change_email_success: 'អ៊ីមែលរបស់អ្នកត្រូវបានផ្លាស់ប្តូរ',
    retrieve_activity_logs_error:
        'មិនអាចយកបញ្ជីនៃកំណត់ហេតុការចូលប្រេីប្រាស់មកវិញបានទេ',
    cannot_reactivate_domain: 'ដែនមិនត្រូវបានគាំទ្រសម្រាប់ការដំណើរការឡើងវិញទេ',
    required_backup_name: 'សូមបញ្ចូលឈ្មោះបម្រុងទុក',
    max_backup_name:
        'ឈ្មោះបម្រុងទុកមិនត្រូវបានអនុញ្ញាតឱ្យធំជាង {max} តួអក្សរទេ',
    cron_hourly: 'ការងារនីមួយៗត្រូវមានចន្លោះពីគ្នាយ៉ាងតិច 1 ម៉ោង',
    invalid_cron_expression: 'cron expression មិនត្រឹមត្រូវ',
    cloud_server_backup_enabled: 'Cloud Server របស់អ្នកត្រូវបានបើកដំណើរការ',
    cloud_server_backup_disabled:
        'ការបម្រុងទុក Cloud Server របស់អ្នកត្រូវបានបិទ',
    cloud_server_backup_restored:
        'ការបម្រុងទុក Cloud Server របស់អ្នកត្រូវបានស្ដារឡើងវិញ',
    cloud_server_backup_rename_success:
        'ឈ្មោះបម្រុងទុក Cloud Server របស់អ្នកត្រូវបានធ្វើបច្ចុប្បន្នភាព',
    send_try_demo_sms_success: 'សារ SMS ត្រូវបានផ្ញើ',
    required_authorization_code: 'សូមបញ្ចូលលេខកូដអនុញ្ញាត',
    max_authorization_code:
        'លេខកូដអនុញ្ញាតមិនត្រូវបានអនុញ្ញាតឱ្យធំជាង {max} តួអក្សរទេ។',
    change_password_success:
        'សំណើររបស់អ្នកកំពុងដំណើរការ។ ពាក្យសម្ងាត់ថ្មី នឹងត្រូវផ្ញើទៅ អ៊ីមែល របស់អ្នកក្នុងពេល ឆាប់ៗនេះ។',
    required: 'ចន្លោះ​នេះ​ត្រូវតែ​បំពេញ',
    invalid_format: 'ទម្រង់​នេះ​​មិន​ត្រឹមត្រូវទេ',
    service_still_expired:
        'កាលបរិច្ឆេទផុតកំណត់ថ្មីគឺ {newExpiration} ដូច្នេះសេវាកម្មរបស់អ្នកនៅតែផុតកំណត់។',
    require_otp: 'សូមបញ្ចូល OTP',
    continue_link_account:
        'ពាក្យសម្ងាត់ និង OTP គឺត្រឹមត្រូវ។ សូមចុចប៊ូតុងខាងក្រោមដើម្បីបន្តភ្ជាប់គណនី Google របស់អ្នក។',
    contract_confirmed: 'កិច្ចសន្យាត្រូវបានបញ្ជាក់',
};
